import React, { useRef, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// A jegytípusok szerkesztése KIZÁRÓLAG a böngésző memóriájában történik (a rendezvény szerkesztő panel állapotában).
// A szerverre csak a rendezvény "Mentés" gombjával kerülnek, a rendezvénnyel együtt.
// Egy jegytípus: a szerver alakja (Id, Nev, Arnetto, ...) + _kulcs (egyedi kliens-azonosító) + _allapot
// (null: változatlan, 'uj': még nincs a szerveren, 'modositott': meglévő, módosítva).

function uresJegytipus() {
    return {
        Id: null, Nev: '', Arnetto: 0, Arafa: 0, Rendezvenyreszlatogato: false, Valaszthato: true,
        Minjegytipusegymegrendelesben: null, Maxjegytipusegymegrendelesben: null, Ferohelyetfoglal: 1,
    };
}

function szamszoveg(ertek) {
    return ertek === null || ertek === undefined ? '' : String(ertek);
}

// űrlap-állapot (mindent szövegként tartunk, hogy a beviteli mezők üresek is lehessenek)
function urlapbol(jt) {
    return Object.assign({}, jt, {
        Arnetto: szamszoveg(jt.Arnetto), Arafa: szamszoveg(jt.Arafa), Ferohelyetfoglal: szamszoveg(jt.Ferohelyetfoglal),
        Minjegytipusegymegrendelesben: szamszoveg(jt.Minjegytipusegymegrendelesben),
        Maxjegytipusegymegrendelesben: szamszoveg(jt.Maxjegytipusegymegrendelesben),
    });
}

function jegytipusra(f) {
    const szam = function (x) { return String(x).trim() === '' ? null : Number(x); };
    return Object.assign({}, f, {
        Nev: f.Nev.trim(),
        Arnetto: Number(f.Arnetto), Arafa: Number(f.Arafa), Ferohelyetfoglal: Number(f.Ferohelyetfoglal),
        Minjegytipusegymegrendelesben: szam(f.Minjegytipusegymegrendelesben),
        Maxjegytipusegymegrendelesben: szam(f.Maxjegytipusegymegrendelesben),
    });
}

// Gyors, kliens oldali ellenőrzés; a szerver a mentéskor újra ellenőriz. Hibaszöveg vagy undefined.
function ellenorzes(f) {
    const egesz = function (x) { return Number.isInteger(Number(x)) && String(x).trim() !== ''; };
    if (f.Nev.trim() === '' || f.Nev.trim().length > 50) { return 'A név kötelező, legfeljebb 50 karakter.'; }
    if (!egesz(f.Arnetto) || Number(f.Arnetto) < 0) { return 'A nettó ár nem negatív egész szám legyen.'; }
    if (!egesz(f.Arafa) || Number(f.Arafa) < 0) { return 'Az áfa nem negatív egész szám legyen.'; }
    const min = String(f.Minjegytipusegymegrendelesben).trim();
    const max = String(f.Maxjegytipusegymegrendelesben).trim();
    if ((min !== '' && (!egesz(min) || Number(min) < 0)) || (max !== '' && (!egesz(max) || Number(max) < 0))) { return 'A minimum és a maximum nem negatív egész szám legyen (vagy üres).'; }
    if (min !== '' && max !== '' && Number(min) > Number(max)) { return 'A minimum nem lehet nagyobb a maximumnál.'; }
    if (!egesz(f.Ferohelyetfoglal) || Number(f.Ferohelyetfoglal) < 0 || Number(f.Ferohelyetfoglal) > 99) { return 'A férőhelyet foglal érték 0 és 99 közötti szám.'; }
    return undefined;
}

// A rendezvény jegytípusai: felül az "Új jegytípus" gomb, alatta soronként a név és az ár, "Szerkesztés" gombbal.
export default function JegytipusokFul({ jegytipusok, onValtozas, csakOlvas }) {
    const [szerkesztes, setSzerkesztes] = useState(undefined);   // {kulcs, urlap}; kulcs undefined = új
    const kulcsSzamlalo = useRef(0);

    function onKesz(kulcs, jt) {
        if (kulcs === undefined) {
            kulcsSzamlalo.current += 1;
            onValtozas(jegytipusok.concat([Object.assign({}, jt, { _kulcs: 'uj' + kulcsSzamlalo.current, _allapot: 'uj' })]));
        } else {
            onValtozas(jegytipusok.map(function (x) {
                return x._kulcs === kulcs ? Object.assign({}, jt, { _kulcs: x._kulcs, _allapot: x._allapot === 'uj' ? 'uj' : 'modositott' }) : x;
            }));
        }
        setSzerkesztes(undefined);
    }

    return (
        <div className="jegytipusokFul">
            {csakOlvas ? undefined :
                <div className="jegytipusFejlec">
                    <Button type="button" variant="primary" size="sm" onClick={function () { setSzerkesztes({ kulcs: undefined, urlap: urlapbol(uresJegytipus()) }); }}>
                        <FontAwesomeIcon icon="fa-plus" /> Új jegytípus
                    </Button>
                </div>
            }
            {jegytipusok.length === 0 ? <div className="adminUres">Ennek a rendezvénynek még nincs jegytípusa.</div> : undefined}
            {jegytipusok.map(function (jt) {
                return (
                    <div key={jt._kulcs} className={'jegytipusSor' + (jt._allapot ? ' valtozott' : '')}>
                        <span className="jegytipusNev">
                            {jt.Nev}
                            {jt._allapot === 'uj' ? <span className="jegytipusJelzo">új</span> : undefined}
                            {jt._allapot === 'modositott' ? <span className="jegytipusJelzo">módosítva</span> : undefined}
                            {jt.Valaszthato === false ? <span className="jegytipusJelzo nemValaszthato" title="A látogatók nem látják, és új megrendelés nem adható le rá.">nem választható</span> : undefined}
                        </span>
                        <span className="jegytipusAr">{Number(jt.Arnetto).toLocaleString('hu-HU')} Ft <small>nettó</small></span>
                        {csakOlvas ? undefined :
                            <Button type="button" variant="outline-primary" size="sm" onClick={function () { setSzerkesztes({ kulcs: jt._kulcs, urlap: urlapbol(jt) }); }}>
                                <FontAwesomeIcon icon="fa-pen" /> Szerkesztés
                            </Button>
                        }
                    </div>
                );
            })}
            {jegytipusok.some(function (jt) { return jt._allapot; }) ?
                <div className="jegytipusFigyelmeztetes">A jegytípusok változásai csak a rendezvény Mentés gombjának megnyomásakor mentődnek.</div>
                : undefined
            }

            {szerkesztes !== undefined ?
                <JegytipusSzerkeszto
                    kezdo={szerkesztes.urlap}
                    onHide={function () { setSzerkesztes(undefined); }}
                    onKesz={function (jt) { onKesz(szerkesztes.kulcs, jt); }} />
                : undefined
            }
        </div>
    );
}

// A jegytípus szerkesztő popup. Szándékosan NEM <form>: az "Kész" gomb csak a memóriabeli listát frissíti,
// nem küld el semmit, és nem érinti a rendezvény szerkesztő panelt.
function JegytipusSzerkeszto({ kezdo, onHide, onKesz }) {
    const [urlap, setUrlap] = useState(kezdo);
    const [hiba, setHiba] = useState(undefined);

    function mezo(nev, ertek) {
        setUrlap(function (regi) { return Object.assign({}, regi, { [nev]: ertek }); });
        setHiba(undefined);
    }

    function onClick_kesz() {
        const h = ellenorzes(urlap);
        if (h !== undefined) {
            setHiba(h);
            return;
        }
        onKesz(jegytipusra(urlap));
    }

    return (
        <Modal show={true} onHide={onHide} backdrop="static" className="felsoModal" dialogClassName="jegytipusDialog" backdropClassName="felsoModalHatter">
            <Modal.Header closeButton>
                <Modal.Title>{urlap.Id === null ? 'Új jegytípus' : 'Jegytípus szerkesztése'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="g-3">
                    <Col md={12}>
                        <Form.Group controlId="jt_nev">
                            <Form.Label>Név</Form.Label>
                            <Form.Control type="text" maxLength={50} value={urlap.Nev} onChange={function (e) { mezo('Nev', e.target.value); }} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="jt_ar">
                            <Form.Label>Nettó ár (Ft)</Form.Label>
                            <Form.Control type="number" min={0} value={urlap.Arnetto} onChange={function (e) { mezo('Arnetto', e.target.value); }} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="jt_afa">
                            <Form.Label>Áfa</Form.Label>
                            <Form.Control type="number" min={0} value={urlap.Arafa} onChange={function (e) { mezo('Arafa', e.target.value); }} />
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="jt_valaszthato">
                            <Form.Label>Választható</Form.Label>
                            <Form.Select value={urlap.Valaszthato === false ? 'nem' : 'igen'} onChange={function (e) { mezo('Valaszthato', e.target.value === 'igen'); }}>
                                <option value="igen">Igen – a látogatók látják</option>
                                <option value="nem">Nem – a látogatók nem látják</option>
                            </Form.Select>
                            <Form.Text muted>A nem választható jegytípusra új megrendelés nem adható le. A jegytípus az adatbázisban marad (a korábbi megrendelések előzményei miatt), csak a látogatók elől tűnik el.</Form.Text>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="jt_reszlatogato">
                            <Form.Label>Rendezvényrész-látogató</Form.Label>
                            <Form.Select value={urlap.Rendezvenyreszlatogato ? 'igen' : 'nem'} onChange={function (e) { mezo('Rendezvenyreszlatogato', e.target.value === 'igen'); }}>
                                <option value="nem">Nem</option>
                                <option value="igen">Igen</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group controlId="jt_min">
                            <Form.Label>Min. egy megrendelésben</Form.Label>
                            <Form.Control type="number" min={0} value={urlap.Minjegytipusegymegrendelesben} onChange={function (e) { mezo('Minjegytipusegymegrendelesben', e.target.value); }} />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group controlId="jt_max">
                            <Form.Label>Max. egy megrendelésben</Form.Label>
                            <Form.Control type="number" min={0} value={urlap.Maxjegytipusegymegrendelesben} onChange={function (e) { mezo('Maxjegytipusegymegrendelesben', e.target.value); }} />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group controlId="jt_ferohely">
                            <Form.Label>Hány férőhelyet foglal</Form.Label>
                            <Form.Control type="number" min={0} max={99} value={urlap.Ferohelyetfoglal} onChange={function (e) { mezo('Ferohelyetfoglal', e.target.value); }} />
                        </Form.Group>
                    </Col>
                    <Col md={12}><Form.Text muted>A min. és a max. mező üresen: nincs korlát.</Form.Text></Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                {hiba !== undefined ? <div className="visszajelzes hiba szerkesztoHiba">{hiba}</div> : undefined}
                <Button type="button" variant="outline-secondary" onClick={onHide}>Mégse</Button>
                <Button type="button" variant="primary" onClick={onClick_kesz}>Kész</Button>
            </Modal.Footer>
        </Modal>
    );
}
